import { Navigate, Route, Routes } from "react-router-dom";
import './i18n';
import Home from "./home/Home";
import AppNavigationBar from "./widgets/AppNavigationBar";
import Footer from "./widgets/Footer";
import { OurWork } from "./ourwork/OurWork";
import { Products } from "./products/Products";
import { Services } from "./services/Services";
import { AboutUs } from "./aboutus/AboutUs";
import { Contact } from "./contact/Contact";
import { MobilePolicies } from "./privacymobile/mobilepolicies";
import { ProjectDetails } from "./projectdetails/ProjectDetails"
import { NotFound } from "./errorpages/NotFound";

function App() {
  return (
    <div className="App">
      <AppNavigationBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/ourwork" element={<OurWork />} />
          <Route path="/services" element={<Services />} />
          {/* The process now lives on the services page. */}
          <Route path="/howwework" element={<Navigate to="/services#process" replace />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mobilepolicies" element={<MobilePolicies />} />
          <Route path="/project/:slug" element={<ProjectDetails />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
